import { render } from "./PledgeTransaction.vue?vue&type=template&id=89e9c5b6&scoped=true"
import script from "./PledgeTransaction.vue?vue&type=script&lang=js"
export * from "./PledgeTransaction.vue?vue&type=script&lang=js"

import "./PledgeTransaction.vue?vue&type=style&index=0&id=89e9c5b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e9c5b6"]])

export default __exports__